import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlashMessage from '../../components/layout/FlashMessage';
import { hideMessage } from '../../actions/FlashMessageActions';

const mapStateToProps = (state) => ({
  flashmessage: state.FlashMessageReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      hideMessage,
    },
    dispatch
  );

const FlashMessageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessage);

export default FlashMessageContainer;
